import { configureStore } from '@reduxjs/toolkit'
import authSlice from './slices/authSlice'
import projectSlice from './slices/projectSlice'
import issueSlice from './slices/issueSlice'
import uiSlice from './slices/uiSlice'
import userSlice from './slices/userSlice'
import leaveSlice from './slices/leaveSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    projects: projectSlice,
    issues: issueSlice,
    ui: uiSlice,
    users: userSlice,
    leaves: leaveSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
